export default __webpack_public_path__ + "static/media/itinerary3_800.c540969b.webp";